import React from 'react';

const ShortLogoLight = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.14758 17.693C-0.382521 16.1635 -0.382526 13.6835 1.14756 12.1539C2.67766 10.6244 5.15842 10.6244 6.68851 12.1539L17.7705 23.2322C19.3006 24.7617 19.3006 27.2417 17.7705 28.7712C16.2404 30.3008 13.7596 30.3008 12.2295 28.7712L1.14758 17.693Z"
        fill="white"
      />
      <path
        d="M17.7706 28.7711C16.2405 30.3007 13.7597 30.3007 12.2296 28.7711C10.6995 27.2415 10.6995 24.7616 12.2296 23.232L23.3116 12.1538C24.8417 10.6242 27.3224 10.6242 28.8525 12.1538C30.3826 13.6834 30.3826 16.1634 28.8525 17.6929L17.7706 28.7711Z"
        fill="white"
      />
      <path
        d="M14.9898 8.64622C17.3556 8.64622 19.2735 6.72899 19.2735 4.36393C19.2735 1.99888 17.3556 0.0816345 14.9898 0.0816345C12.6239 0.0816345 10.7061 1.99888 10.7061 4.36393C10.7061 6.72899 12.6239 8.64622 14.9898 8.64622Z"
        fill="#FBC91B"
      />
    </svg>
  );
};

export default ShortLogoLight;
